import { Component, OnInit } from '@angular/core';
import { Department, ResponseDataBase } from '../../../../interfaces/index.interface';
import { ResourceService } from '../../../../services/index.service';
import { DatabaseResourcesService } from '@services/database-resources/database-resources.service';
import { AppConstants } from '@app/appConstants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from '@components/modals/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';

declare var $: any;

@Component({
  selector: 'database-resources-departments',
  templateUrl: './departments.page.html'
})
export class DepartmentsPage implements OnInit {

  departments;
  alert;
  action;
  department: Department;
  hospital;
  hospitals;
  newDepartment: Department = {
    id: '',
    name: '',
    hospitalId: '',
    actived: false
  };
  storeActived;

  constructor(public _resourceService: ResourceService, public modalService: NgbModal
    , public _databaseResourcesService: DatabaseResourcesService, public translate: TranslateService) {
    this.department = this.newDepartment;

    if (!_databaseResourcesService.haveAllResources()) {
      this._databaseResourcesService.getAllResources();
    }

  }

  getAllHospitals() {
    this._resourceService.getResource('allhospitals')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.hospital = response.result[0];
        this.hospitals = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  getDepartments(hospital) {
    let params = {
      hospitalId: hospital.id,
    };
    this._databaseResourcesService.getDepartments(params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.departments = response.result;
        this._databaseResourcesService.loading = false;
      });
  }

  addDepartment() {
    if (this.department.name && this.department.id) {
      delete this._resourceService.alert;
      this.department.hospitalId = this.hospital.id
      let params: Department = this.department;
      this._databaseResourcesService.addDepartment(params).subscribe(data => {
        let response = data as ResponseDataBase;
        $('#departmentModal').modal('hide');
        if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
          this.getDepartments(this.hospital);
        } else {
          this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
        }
        this._databaseResourcesService.loading = false;
      });
    } else {
      this._resourceService.alert = 'PLEASE_FILL_FIELDS_MARKS_WITH';
    }
  }

  editDepartment(department) {
    delete this._resourceService.alert;
    this.action = 'update';
    this.department = department;
    this.storeActived = this.department.actived;
  }

  updateDepartment() {
    let params: Department = {
      id: this.department.id,
      name: this.department.name,
      hospitalId: this.hospital.id,
      actived: this.department.actived
    }
    this._databaseResourcesService.updateDepartment(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        $('#departmentModal').modal('hide');
        this.getDepartments(this.hospital);
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
      this._databaseResourcesService.loading = false;
    });
  }

  deleteDepartment(department) {
    let modal = this.modalService.open(ConfirmationModalComponent, {
      windowClass: 'modal-fade',
      backdrop: 'static',
      keyboard: false,
      size: 'sm'
    });
    modal.componentInstance.header = 'DELETE_DEPARTMENT';
    modal.componentInstance.message = 'CONFIRM_DELETE';
    modal.componentInstance.data = { action: "delete", department: department };
    modal.componentInstance.action.subscribe((response) => {
      this.confirmDeleteDepartment(response.department);
    });
  }

  confirmDeleteDepartment(department) {
    let params = {
      departmentId: department.id,
    };
    this._databaseResourcesService.deleteDepartment(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.translate.get('HAS_BEEN_DELETED').subscribe(
          translation => {
            let name = department.name
            this.alert = name + " " + translation;
          });
        this.getDepartments(this.hospital);
      } else {
        this.alert = response.METADATA.ERROR_MESSAGE;
        this._databaseResourcesService.loading = false;
      }
    });
  }

  cancelEdit() {
    this.department.actived = this.storeActived;
    delete this.action;
  }

  sync(hospital) {
    let params = {
      hospitalId: hospital.id
    };
    this._resourceService.getResourceWithParams('departments', params)
      .subscribe(data => {
        let response = data as ResponseDataBase;
        response.result.forEach((department) => {
          let founded = this.departments.filter(DBDepartment => DBDepartment.id === department.id);
          delete department.warnMessage;
          delete department.popup;
          delete department.useAsTreatment;
          if (!founded[0]) {
            department.actived = false;
            this._databaseResourcesService.addDepartment(department).subscribe(data => {
              let response = data as ResponseDataBase;
            });
            let params = {
              hospitalId: hospital.id
            };
            this._databaseResourcesService.getDepartments(params).subscribe(data => {
              let response = data as ResponseDataBase;
              if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
                this.departments = response.result;
              } else {
                this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
              }
              this._databaseResourcesService.loading = false;
            });
          }
        });
        this._resourceService.loading = false;
      });

  }


  ngOnInit() {
  }

}
